import {HttpClient, HttpParams} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {AppConfigService} from '@/core/config/app-config.service';
import {PagedListResult} from '@/core/models/api-response.model';
import {skipLoader} from '@/core/loading/loader.interceptor';
import {
    CreateExportAuditLogDto, ImportExportLogDto, ImportExportLogQuery,
} from '@/features/audit/models/import-export-log.model';
import {apiUtcDate, toPagedResult} from '@shared/utils/api-envelope';

/** Import / export history (`/api/v1/import-export-logs` on the audit-log backend). */
@Injectable({providedIn: 'root'})
export class ImportExportLogService {
    private readonly http = inject(HttpClient);
    private readonly appConfig = inject(AppConfigService);

    /** Files with at least one record, newest first by default; unset query fields are not sent. */
    loadPage(query: ImportExportLogQuery): Observable<PagedListResult<ImportExportLogDto>> {
        let params = new HttpParams();
        for (const [key, value] of Object.entries(query)) {
            const text = typeof value === 'string' ? value.trim() : value;
            if (text !== undefined && text !== null && text !== '') params = params.set(key, text);
        }
        return this.http.get<unknown>(`${this.appConfig.baseUrl('auditLog')}/api/v1/import-export-logs`, {params}).pipe(
            map((body) => {
                const page = toPagedResult<ImportExportLogDto>(body, query.pageNumber, query.pageSize);
                return {...page, items: page.items.map((dto) => ({...dto, createdDate: apiUtcDate(dto.createdDate)}))};
            }),
        );
    }

    /** Records an export in the log, without the global loader (it runs after the download). */
    recordExport(body: CreateExportAuditLogDto): Observable<unknown> {
        return this.http.post(`${this.appConfig.baseUrl('auditLog')}/api/v1/export-auditlogs`, body, {context: skipLoader()});
    }
}
